<template>
    <div id="contenidorPDF">
        <div>
            <b-card class="resumCercaCard">
                <h2>
                    {{ $t("fitxes.titols.estas") }}
                </h2>
                <p>
                    {{ $t("fitxes.titols.resultats")}}
                    {{ unitat.label || unitat.text || '' }}
                    {{ $t("fitxes.titols.resultats2")}}
                </p>
                <ul>
                    <li v-for="([clau, dades], index) in liniesAssistencials" :key="clau">
                    <p>{{ getLetter(index) }} - {{ $t("variables.liniaAssistencialFitxes." + clau.toUpperCase()) }}
                    (any {{ dades.anysDisponibles && dades.anysDisponibles[0] || '?' }})
                        </p>
                </li>
                </ul>
            
                <!-- Llegenda de colors -->
                <div class="llegendaColors">
                    <div class="llegendaTitle">
                        {{ $t("fitxes.titols.llegendaColors") }}
                    </div>
                    <div class="itemLlegenda">
                        <span class="box verd"></span>
                        <span>{{ $t("fitxes.llegenda.positiva") }}</span>
                    </div>
                    <div class="itemLlegenda">
                        <span class="box vermell"></span>
                        <span>{{ $t("fitxes.llegenda.negativa") }}</span>
                    </div>
                </div>
            </b-card>
        </div>
        <div class="containerDades containerDadesUrgencies">
        <div class="leftTitle">
            <h2 v-show="liniaAssistencial">
            {{ $t("variables.liniaAssistencialFitxes." + liniaAssistencial.toUpperCase()) }} 
            ({{ anysDisponibles && anysDisponibles[0] || '?' }})
            </h2>
        </div>
        <div class="dadesFitxa">
            <b-table-simple class="taulaDades">
                <b-thead>
                    <b-tr>
                        <b-th></b-th>
                        <b-th class="taula-header">
                            {{ $t("fitxes.titols.catalunya") }} {{ anysDisponibles[0] }}
                        </b-th>
                        <b-th
                            v-for="(any) in anysDisponibles"
                            :key="'head-any-' + any"
                            class="taula-header"
                            >
                            {{ $t("fitxes.titols.up") }} {{ any }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in dadesLiniaAssistencial.preguntes" :key="index">
                        <!-- Columna de enunciat -->
                        <b-td class="casellaPregunta">
                        <p>{{ item.enunciat }}</p>
                        </b-td>

                        <!-- Columna percCatalunya -->
                        <b-td class="casellaPercent">
                        <p class="casellaCat">{{ item.percCatalunya || '-' }}</p>
                        </b-td>

                        <!-- Columnas por any -->
                        <b-td
                        v-for="(any, idx) in anysDisponibles"
                        :key="'val-' + any + '-' + index"
                        class="casellaPercent"
                        >
                        <p :class="idx === 0 ? percentClass(item) : 'casellaDefault'">
                            {{
                            idx === 0 ? item.percAnyActual :
                            idx === 1 ? item.percAnyAnterior :
                            item.percAnyAnterior2
                            }}
                        </p>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
        </div>
    </div> 
</template>

<script>
export default {
    name: "ModalTaulaResultatsEnquestaPlaensa",
    props: {
        liniaAssistencial: {
            type: String,
            required: true
        },
        dadesLiniaAssistencial: {
            type: Object,
            required: true
        },
        anysDisponibles: Array,
        ambit: {
            type: String,
            required: true
        },
        regio: {
            type: String,
            required: true
        },
        entitat: {
            type: Object,
            required: true
        },
        unitat: {
            type: Object,
            required: true
        },
        resposta: {
            type: Object,
            required: true
        }
    },
    data(){
        return {

        };
    },
    computed: {
        liniesAssistencials() {
            if (!this.resposta || !this.resposta.resultats) return [];
            return Object.entries(this.resposta.resultats);
        }
    },
    methods: {
    percentClass(item) {
        if (!item || !item.color) return 'casellaDefault';
        if (item.color === 'VERD') return 'casellaSuccess';
        if (item.color === 'VERMELL') return 'casellaError';
        return 'casellaDefault';
    },
    getLetter(index) {
    return String.fromCharCode(97 + index); // a, b, c...
    },

    getNomLinia(index) {
        const clau = Object.keys(this.resposta.liniaAssistencial)[index];
        return this.$t("variables.liniaAssistencialFitxes." + clau.toUpperCase());
    }

    },
    mounted(){

    }
};
</script>

<style>
.containerDades{
    border-color: #900000;
    background-color: #f0f2f3;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    float: left;
    width: 100%;
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    min-height: 100px; 
}

.dadesFitxa {
    float: left;
    width: 95%;
    padding-right: 1rem;
}

.leftTitle {
    background-color: #900000;
    color: #fdfeff;
    width: 5%;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
}

.leftTitle h2 {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 1.4rem; 
    font-weight: bold;
    margin: 0;
    text-align: center;
    line-height: 1.2;
}

.taulaDades{
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 1rem;
}

.taulaDades, 
.taulaDades th, 
.taulaDades td, 
.taulaDades tr, 
.taulaDades thead, 
.taulaDades tbody {
    border: none !important;
    box-shadow: none !important;
    border-collapse: collapse !important;
    padding: 0.5rem;
}

.taulaDades th, 
.taulaDades td {
    border: none !important;
    background-color: transparent !important;
}

.taulaDades {
    border-spacing: 0 !important;
}

.casellaPregunta{
    padding-left: 3rem;
    padding-right: 8rem;
    text-align: left;
}

td.casellaPregunta {
    padding-left: 2rem;
    padding-right: 7rem;
}

.casellaPregunta p {
    border-width: 1px;
    border-color: #900000;
    border-style: solid;
    border-radius: 9px;
    padding-left: 1rem;
    padding-right: 3rem;
    margin: 0;
    max-width: 100%;
}

.casellaPercent p{
    margin: 0;
    padding-bottom: 0.5rem;
    width: 90%;
}

.center-cell{
    display: flex;
    justify-content: center;
    align-items: center;
}

.taula-header{
    width: 11%;
    font-weight: normal;
}

.casellaDefault{
    color:white;
    background-color: #c7c9c9;
    border-color: #c7c9c9;
    border-width: 1px;
    border-style: solid;
    border-radius: 9px;
    padding: 0;
}
.casellaError{
    color:white;
    background-color: #e1736d;
    border-color: #e1736d;
    border-width: 1px;
    border-style: solid;
    border-radius: 9px;
    padding: 0;
}
.casellaSuccess{
    color:white;
    background-color: #25b574;
    border-color: #25b574;
    border-width: 1px;
    border-style: solid;
    border-radius: 9px;
    padding: 0;
}
td.casellaPercent {
    padding-bottom: 0.5rem;
}
.casellaPregunta{
    padding-bottom: 0.5rem;
}
.resumCercaCard {
  border-color: #c7c9c9;
    background-color: #f0f2f3;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    float: left;
    width: 100%;
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    min-height: 100px;
}

.resumCercaCard h2 {
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: left;
}

.resumCercaCard p {
  font-size: 1rem;
  color: #333;
  margin-bottom: 0;
  text-align: left;
}

.casellaPercent .casellaDefault{
    color:white;
    background-color: #c7c9c9;
    border-color: #c7c9c9;
    border-width: 1px;
    border-style: solid;
    border-radius: 9px;
    padding: 0;
    padding-bottom: 0.5rem;
}

.casellaPercent .casellaCat{
    color:white;
    background-color: #62a3e2;
    border-color: #62a3e2;
    border-width: 1px;
    border-style: solid;
    border-radius: 9px;
    padding: 0;
    padding-bottom: 0.5rem;
}

.llegendaColors {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  font-size: 0.95rem;
}

.itemLlegenda {
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
}

.itemLlegenda .box {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin-right: 0.5rem;
}

.itemLlegenda .verd {
  background-color: #25b574;
}

.itemLlegenda .vermell {
  background-color: #e1736d;
}

.itemLlegenda .text {
  color: #333;
}
.llegendaTitle {
  font-weight: bold;
  margin-bottom: 0.4rem;
  text-align: left;
  color: #333;
}

#contenidorPDF {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

</style>